import { render, staticRenderFns } from "./AccessManager.vue?vue&type=template&id=25459258&scoped=true"
import script from "./AccessManager.vue?vue&type=script&lang=ts"
export * from "./AccessManager.vue?vue&type=script&lang=ts"
import style0 from "./AccessManager.vue?vue&type=style&index=0&id=25459258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25459258",
  null
  
)

export default component.exports